import { render, staticRenderFns } from "./InspeccionVehiculo.vue?vue&type=template&id=92cb1372"
import script from "./InspeccionVehiculo.vue?vue&type=script&lang=js"
export * from "./InspeccionVehiculo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports